import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { isAllowEdit } from 'features/supplier/utils';

import BankDetails from '@features/supplier/component/BankDetails';
import Contact from '@features/supplier/component/Contact';
import Location from '@features/supplier/component/Location';
import RatingAndReview from '@features/supplier/component/RatingAndReview';
import SourcingTeam from '@features/supplier/component/SourcingTeam';
import TeamManagement from '@features/supplier/component/TeamManagement';

const Other = ({ detailsInfo }) => {
	const [selectedField, setSelectedField] = useState('LOCATION');
	const [isAdd, setIsAdd] = useState(false);

	const { id } = useParams();
	const onSetAdd = () => {
		setIsAdd(false);
	};
	return (
		<div className="other-information-section">
			<div className="location-section" id="location-section">
				<div className="tabs-header d-flex justify-content-between align-items-center">
					<div className="one-half">
						<h3 className="font-weight-bold regular-16 gray_dark_01 text-uppercase">
							Other Information
						</h3>
					</div>
				</div>
				<div className="all-info-tabs">
					<div className="info-tabs inner-tabs d-flex">
						<ul className="flex-wrap">
							<li
								onClick={() => {
									setIsAdd(false);
									setSelectedField('LOCATION');
								}}
								className={selectedField === 'LOCATION' ? 'active' : ''}
							>
								Location
							</li>
							<li
								onClick={() => {
									setIsAdd(false);
									setSelectedField('BANK');
								}}
								className={selectedField === 'BANK' ? 'active' : ''}
							>
								Bank info
							</li>
							<li
								onClick={() => {
									setIsAdd(false);
									setSelectedField('SOURCE');
								}}
								className={selectedField === 'SOURCE' ? 'active' : ''}
							>
								Sourcing team
							</li>
							<li
								onClick={() => {
									setIsAdd(false);
									setSelectedField('CONTACT');
								}}
								className={selectedField === 'CONTACT' ? 'active' : ''}
							>
								Contact
							</li>
							<li
								onClick={() => {
									setIsAdd(false);
									setSelectedField('TEAM_MANAGEMENT');
								}}
								className={selectedField === 'TEAM_MANAGEMENT' ? 'active' : ''}
							>
								Team Management
							</li>
							<li
								onClick={() => {
									setIsAdd(false);
									setSelectedField('RATING');
								}}
								className={selectedField === 'RATING' ? 'active' : ''}
							>
								Supplier rating
							</li>
						</ul>
						{!['LOCATION', 'TEAM_MANAGEMENT'].includes(selectedField) &&
							(selectedField !== 'RATING' ? isAllowEdit() : true) && (
								<div>
									<span onClick={() => setIsAdd(true)}>
										<button className="blue border-0 medium-14 bg-transparent ml-3">
											{selectedField === 'SOURCE'
												? 'Edit'
												: selectedField === 'RATING'
													? 'Rate this supplier'
													: 'Add'}
										</button>
									</span>
								</div>
							)}
					</div>

					{selectedField === 'LOCATION' && (
						<Location
							supplierId={id}
							officeLocationInfo={detailsInfo?.officeLocation}
							factoryLocationInfo={detailsInfo?.factoryLocation}
							isAdd={isAdd}
							onSetAdd={onSetAdd}
						/>
					)}

					{selectedField === 'BANK' && (
						<BankDetails supplierId={id} isAdd={isAdd} onSetAdd={onSetAdd} />
					)}
					{selectedField === 'SOURCE' && (
						<SourcingTeam supplierInfo={detailsInfo} isAdd={isAdd} onSetAdd={onSetAdd} />
					)}
					{selectedField === 'CONTACT' && (
						<Contact
							isAdd={isAdd}
							onSetAdd={onSetAdd}
							supplierId={id}
							data={detailsInfo.contactPersonResponseList}
							webAddress={detailsInfo.website}
						/>
					)}
					{selectedField === 'RATING' && <RatingAndReview isAdd={isAdd} onSetAdd={onSetAdd} />}
					{selectedField === 'TEAM_MANAGEMENT' && (
						<TeamManagement isAdd={isAdd} onSetAdd={onSetAdd} />
					)}
				</div>
			</div>
		</div>
	);
};

export default Other;
